export default __webpack_public_path__ + "static/media/double-check.c079f104.webp";